import { type ReactElement } from 'react';

import styles from './LoadingSpinner.module.css';

type LoadingSpinnerProps = {
  variant?: 'ai' | 'dark' | 'default';
  'data-testid'?: string;
};
export const LoadingSpinner = ({ variant = 'default', 'data-testid': dataTestId }: LoadingSpinnerProps): ReactElement => (
  <div className={styles.container} data-testid={dataTestId}>
    {variant === 'ai' && (
      <>
        <svg className={styles.track} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="gradient-track" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#BB2D7C" />
              <stop offset="50%" stopColor="#7244E7" />
              <stop offset="100%" stopColor="#256DA6" />
            </linearGradient>
          </defs>
          <circle cx="12" cy="12" r="8" stroke="url(#gradient-track)" strokeWidth="2" strokeOpacity="0.4" />
        </svg>
        <svg className={styles.spinningSegment} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle
            cx="12"
            cy="12"
            r="8"
            stroke="rgba(37, 109, 166, 0.6)"
            strokeWidth="2"
            fill="none"
            strokeDasharray="12.566 50.265"
            strokeLinecap="round"
          />
        </svg>
      </>
    )}
    {variant === 'dark' && (
      <>
        <svg className={styles.track} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="8" stroke="#9CA3AF" strokeOpacity="0.4" strokeWidth="2" />
        </svg>
        <svg className={styles.spinningSegment} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle
            cx="12"
            cy="12"
            r="8"
            stroke="#6B7280"
            strokeWidth="2"
            fill="none"
            strokeDasharray="12.566 50.265"
            strokeLinecap="round"
          />
        </svg>
      </>
    )}
    {variant === 'default' && (
      <>
        <svg className={styles.track} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="8" stroke="#FFFDFD" strokeOpacity="0.4" strokeWidth="2" />
        </svg>
        <svg className={styles.spinningSegment} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="8" stroke="white" strokeWidth="2" fill="none" strokeDasharray="12.566 50.265" strokeLinecap="round" />
        </svg>
      </>
    )}
  </div>
);
